import {EntitySnapshot, ReactionSystem} from "tick-knock";
import {FieldView} from "@game/coregame/view/FieldView";
import {Population} from "@game/coregame/view/Population";
import {StateShapeView} from "@game/coregame/view/StateShapeView";
import {CapitalView} from "@game/coregame/view/CapitalView";
import {DisplayObject} from "pixi.js-legacy";
import {TutorialFingerView} from "@game/coregame/view/TutorialFingerView";

export class DisplaySystem extends ReactionSystem {
    constructor(private fieldView: FieldView) {
        super(entity => entity.hasAny(Population, StateShapeView, CapitalView, TutorialFingerView));
    }

    entityAdded = (snapshot: EntitySnapshot) => {
        const {current: entity} = snapshot;
        const population = entity.get(Population);
        const shape = entity.get(StateShapeView);
        const center = entity.get(CapitalView);
        const tutorialFinger = entity.get(TutorialFingerView);

        population && this.fieldView.labels.addChild(population);
        shape && this.fieldView.shapes.addChild(shape);
        center && this.fieldView.capitals.addChild(center);
        tutorialFinger && this.fieldView.addChild(tutorialFinger);
    };
    entityRemoved = (snapshot: EntitySnapshot) => {
        const {previous: entity} = snapshot;

        [Population, StateShapeView, CapitalView, TutorialFingerView].forEach(
            (ViewClass: typeof DisplayObject) => {
                const view = entity.get(ViewClass);
                view?.parent?.removeChild(view);
            }
        );
    };
}
